import { render, staticRenderFns } from "./AddNewDropdownDialogs.vue?vue&type=template&id=14a2ef2b&scoped=true"
import script from "./AddNewDropdownDialogs.vue?vue&type=script&lang=js"
export * from "./AddNewDropdownDialogs.vue?vue&type=script&lang=js"
import style0 from "./AddNewDropdownDialogs.vue?vue&type=style&index=0&id=14a2ef2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a2ef2b",
  null
  
)

export default component.exports